import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { useCategoriesComparison } from "../categories-context";

import { IndustryAnalysisGeographyComparisonTable } from "./components/IndustryAnalysisGeographyComparisonTable";
import { IndustryAnalysisGeographyMapWidget } from "./components/IndustryAnalysisGeographyMapWidget";
import { IndustryAnalysisGeographyTableContainer } from "./components/IndustryAnalysisGeographyTableContainer";
import { IndustryAnalysisGeographyTrafficAndEngagementTabs } from "./components/IndustryAnalysisGeographyTrafficAndEngagementTabs";
import { useProcessedGeographyTableData } from "./hooks/useProcessedGeographyTableData";

export const IndustryAnalysisGeographyContainer = () => {
    const { isPrimaryMode } = useCategoriesComparison();

    // Shared table data state for both table and chart components
    const tableDataState = useProcessedGeographyTableData();

    return (
        <Stack gap="24px">
            <IndustryAnalysisGeographyMapWidget />
            {isPrimaryMode ? (
                <Flex flexDirection="column">
                    <IndustryAnalysisGeographyTrafficAndEngagementTabs tableDataState={tableDataState} />
                    <IndustryAnalysisGeographyTableContainer tableDataState={tableDataState} />
                </Flex>
            ) : (
                <IndustryAnalysisGeographyComparisonTable />
            )}
        </Stack>
    );
};
